import React, { useEffect, useState } from 'react';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { useT } from 'client/i18n/hooks/useT';

export function SubmitButton(props: {
  isSubmitting: boolean;
  pristine: boolean;
}) {
  const { pristine, isSubmitting } = props;
  const [isActive, setIsActive] = useState(false);
  const t = useT();

  function getText() {
    if (isActive && isSubmitting) {
      return t('Button.Saving', 'Saving...', 'Saving button text');
    }
    return t(
      'EpisodeEditorPublish.InteractiveQuestionForm.SubmitButton.PublishQuestionButtonLabel',
      'Publish question',
      'Publish question button text'
    );
  }

  useEffect(() => {
    if (!isSubmitting) {
      setIsActive(false);
    }
  }, [isSubmitting]);

  return (
    <ButtonPrimary
      type="submit"
      disabled={isSubmitting || pristine}
      onClick={() => {
        setIsActive(true);
      }}
    >
      {getText()}
    </ButtonPrimary>
  );
}
